import _ from 'lodash';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { Subscription } from 'rxjs';
import { FormControl, FormGroup, FormArray } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private cookieService: CookieService
  ) { }


  getOrgDonations(p) {
    let params = {
      campaignIds:[],
      donationType:[],
      endDate:p.endDate,
      paymentMethod:[],
      recurring:0,
      startDate:p.startDate,
      status:[],
      timeZone:(new Date()).getTimezoneOffset()*-60,
      useCreatedDate:false
    }
    const queryParams = [
      `access_token=${this.cookieService.get('accessToken')}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('/api/getOrgDonations', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getCampaignReport(p) {
    let params = {
      endDate:p.endDate,
      startDate:p.startDate,
    }
    const queryParams = [
      `access_token=${this.cookieService.get('accessToken')}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('/api/campaignReport', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  addCommasToNumber(number) {
    const numberString = number.toFixed(2).replace(/\.?0+$/, '');
    const parts = numberString.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const formattedNumber = parts.join(".");
    return formattedNumber;
  }
}